module.exports = __webpack_public_path__ + "static/media/IconJira.236e62b9.png";